module.exports = __webpack_public_path__ + "img/portrait-046.7cd7140c.jpg";